import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import SVNCounts from "../components/svnCounts";

const SmartClassRooms = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
        AOS.init({ duration: 1000 });
    }, []);
    return (
        <div className="container mx-auto px-6 py-12">
            {/* Heading */}
            <h1 className="text-3xl font-bold text-center mb-6">SMART CLASSROOMS</h1>


            <div className="w-full " data-aos="fade-up">
                <p className="text-lg  text-gray-700 leading-relaxed">
                    Smart classrooms are digital classrooms which is an advanced form of a school that follows different ways of teaching to improve efficiency virtually. Our school works towards providing a better environment for learning and prioritise a healthy classroom where learning is made fun for students.
                </p>
            </div>


            {/* Image Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 mt-8" data-aos="fade-up">
                <img src="https://img.freepik.com/free-photo/multiethnic-pupils-doing-task-with-help-teacher_74855-10288.jpg?ga=GA1.1.736731524.1738591350&semt=ais_hybrid" alt="Smart Classroom 1" className="w-full h-48 object-cover rounded-lg shadow-md" />
                <img src="https://img.freepik.com/free-photo/multiethnic-pupils-doing-task-with-help-teacher_74855-10288.jpg?ga=GA1.1.736731524.1738591350&semt=ais_hybrid" alt="Smart Classroom 2" className="w-full h-48 object-cover rounded-lg shadow-md" />
                <img src="https://img.freepik.com/free-photo/multiethnic-pupils-doing-task-with-help-teacher_74855-10288.jpg?ga=GA1.1.736731524.1738591350&semt=ais_hybrid" alt="Smart Classroom 3" className="w-full h-48 object-cover rounded-lg shadow-md" />
                <img src="https://img.freepik.com/free-photo/multiethnic-pupils-doing-task-with-help-teacher_74855-10288.jpg?ga=GA1.1.736731524.1738591350&semt=ais_hybrid" alt="Smart Classroom 4" className="w-full h-48 object-cover rounded-lg shadow-md" />
            </div>
        </div>
    );
}

export default SmartClassRooms;





